import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { DiagnosticCard } from '@bingads-webui-campaign-react/diagnostic-card';
import { PerfMarkerFactory } from '@bingads-webui/performance-marker';

import { useData } from './use-data';
import { DiagnosticCardShimmer } from './shimmer';

let perfMarker = null;

export function OverviewDiagnosticCard(props) {
  const {
    serverContext,
    i18n,
    sesId, // This prop is used for force refreshing card data
    perfMarkerUtils,
    responsiveSize,
    campaignType,
  } = props;

  if (_.isEmpty(perfMarker)) {
    perfMarker = PerfMarkerFactory.createMarker('Overview_DiagnosticCard');
  }
  useEffect(() => perfMarker.willInit(), []);

  const {
    details,
    campaignStatusTitle,
    campaignStatusMsg,
    isDataFetchDone,
  } = useData({
    serverContext,
    i18n,
    perfMarker,
    sesId,
    campaignType,
  });

  if (!isDataFetchDone) {
    return <DiagnosticCardShimmer responsiveSize={responsiveSize} />;
  }

  perfMarkerUtils.done();

  return (
    <DiagnosticCard
      campaignStatusTitle={campaignStatusTitle}
      campaignStatusMsg={campaignStatusMsg}
      details={details}
      i18n={i18n}
      responsiveSize={responsiveSize}
    />
  );
}

OverviewDiagnosticCard.propTypes = {
  serverContext: PropTypes.shape({
    Urls: PropTypes.shape({
      ClientCenterBaseUrl: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  sesId: PropTypes.number,
  perfMarkerUtils: PropTypes.shape({
    done: PropTypes.func.isRequired,
  }).isRequired,
  responsiveSize: PropTypes.string.isRequired,
  campaignType: PropTypes.string.isRequired,
};

OverviewDiagnosticCard.defaultProps = {
  sesId: -1,
};
